import React from "react";
import TablaCampana from "js/pages/Admin/Programa/Campana/Tabla";

function Campana(props) {
  return <TablaCampana {...props} />;
}

export default Campana;
